module.exports = __webpack_public_path__ + "img/s2-1-ja.b05f472f.jpg";